export default "__VITE_ASSET__uMoWJPw0__"